<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"><a id="page_iv"></a> </p>
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="copyright">This is a work of fiction. All of the characters, organizations, and events portrayed in this novel are either products of the author’s imagination or are used fictitiously.</p>
<p class="linespace"> </p>
<p class="copyright1"><span class="small">THOMAS DUNNE BOOKS.</span><br/>An imprint of St. Martin’s Press.</p>
<p class="copyright"><span class="small">ANCIENTS.</span> Copyright © 2008 by David Lynn Golemon. All rights reserved. Printed in the United States of America. For information, address St. Martin’s Press, 175 Fifth Avenue, New York, N.Y. 10010.</p>
<p class="copyright"><a href="http://www.thomasdunnebooks.com" target="_blank">www.thomasdunnebooks.com</a><br/><a href="http://www.stmartins.com" target="_blank">www.stmartins.com</a></p>
<p class="copyright">Maps by Paul J. Pugliese</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication Data</p>
<p class="copyright2">Golemon, David Lynn.</p>
<p class="copyright3">Ancients : an Event Group thriller / David Lynn Golemon.—1st ed.</p>
<p class="copyright3">         p. cm.</p>
<p class="copyright3">ISBN-13: 978-0-312-35264-6</p>
<p class="copyright3">ISBN-10: 0-312-35264-6</p>
<p class="copyright3">1. Event Group (Imaginary organization)—Fiction. 2. Atlantis (Legendary place)—Fiction. 3. United States—Politics and government—Fiction. 4. Imaginary wars and battles—Fiction. 5. Weapons of mass destruction—Fiction. 6. Technology—Social aspects—Fiction. 7. Earthquakes—Fiction. I. Title.</p>
<p class="copyright3">PS3607.O4555A53   2008</p>
<p class="copyright3">813′.6—dc22</p>
<p class="copyrightr">2008012927</p>
<p class="copyright">First Edition: August 2008</p>
<p class="copyright">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?59e09c26